const invalidMessage = (value) => `Invalid ${value} format`;

export const EMAIL_MESSAGE = invalidMessage('email');

export const REQUIRE_MESSAGE = 'This field is required!';